import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
    successAlertDispatcher,
    errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { FIELDS } from "./bank_constants";
import { FEATURES } from "../../../utils/constant";
import { aesDecrypt } from "../../../utils/commonFunctionalities";

class Bank extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: [],
            loadingData: true,
        };
    }

    componentDidMount() {
       this.getBankDetails();
    }

    getBankDetails = ()=>{
        ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/bank` })
                    .then(async(dataArray) => {
                        if(dataArray?.data?.resultSet?.length){
                            for(let data of dataArray.data.resultSet){
                              if(data.accountNo) data.accountNo = await aesDecrypt(data.accountNo);
                              if(data.ifscCode) data.ifscCode = await aesDecrypt(data.ifscCode);
                            }
                            this.setState({ loadingData: false, rowData: dataArray.data.resultSet });
                          }else{
                            this.setState({ loadingData: false, rowData: [] });
                          }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.setState({ loadingData: false, rowData: [] });
                    });
    }

    onCellClicked = (rowData) => {
        typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }

    onRowEdit = (rowData) => {
        this.props.history.push("/edit-bank", {
            ...rowData,
            title: "edit_title",
        });
    };

    onRowDelete = (alert) => {
        if (alert.type === "success") this.props.successAlert(alert);
        else this.props.errorAlert(alert);
        this.props.history.push("/bank");
        this.props.history.go();
    };

    render() {
        const { rowData } = this.state;
        const { t } = this.props;
        const Columns = [
            {
                headerName: FIELDS.bank_code.title || "Bank Code",
                field: "bankCode",
                sortable: true,
                filter: true,
            },
            {
                headerName: FIELDS.bank_name.title || "Bank Name",
                field: "bankName",
                sortable: true,
                filter: true,
            },
            {
                headerName: FIELDS.account_code.title || "Account Code",
                field: "accountCode",
                sortable: true,
                filter: true,
            },
            {
                headerName: FIELDS.account_name.title || "Account Holder Name",
                field: "accountName",
                sortable: true,
                filter: true,
            },
            {
                headerName: FIELDS.account_no.title || "Account Number",
                field: "accountNo",
                sortable: true,
                filter: true,
            },
            {
                headerName: FIELDS.ifsc_code.title || "IFSC Code",
                field: "ifscCode",
                sortable: true,
                filter: true,
            },
            {
                headerName: FIELDS.created_by || "Created By",
                field: "createdBy",
                sortable: true,
                filter: true,
            },
            {
                headerName: FIELDS.created_on || "Created On",
                field: "createdOn",
                sortable: true,
                filter: true,
            },
            {
                headerName: FIELDS.updated_by || "Modified By",
                field: "updatedBy",
                sortable: true,
                filter: true,
            },
            {
                headerName: FIELDS.updated_on || "Modified On",
                field: "updatedOn",
                sortable: true,
                filter: true,
            },
            {
                headerName: FIELDS.edit || "Edit / Delete",
                field: "edit",
                cellRenderer: "actionRenderer",
                suppressToolPanel: true,
                pinned: "right",
            },
        ];
        return (
            <React.Fragment>
                <AgGridTable
                    isLoading={this.state.loadingData}
                    columnDefs={Columns}
                    rowData={rowData}
                    titleBarTitle={"Bank"}
                    titleBarLink={"/add-bank"}
                    baseURL={"bank"}
                    pathName={"bank"}
                    keyIndex={"bankId"}
                    onEdit={this.onRowEdit}
                    cellDoubleClicked={this.onCellClicked}
                    onDelete={this.onRowDelete}
                    hideFilter={true}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                    importHidden={true}
                />
            </React.Fragment>
        );
    }
}
const mapStateToProps = ({ permissions }) => {
    return {
        permissions,
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
        errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("bank")(Bank));
